import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import DateTime from '_class/DateTime';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { searchGroups, clearSearch } from 'actions/search';
import { getGroupAbsenceForToday, getMentorGroups, getArchievedMentorGroups } from 'actions/sections';
import { setPageTitle } from 'actions/header';
import LoadingCards from 'components/Cards/LoadingCard';
import { Expandable } from 'UI';
import { Search as SearchInput } from 'UI/Inputs';
import { Card, Icon, Flex } from '@haldor/ui';
import { getDescription } from 'helpers/content';

var MentorGroups = /*#__PURE__*/function (_Component) {
  _inherits(MentorGroups, _Component);

  var _super = _createSuper(MentorGroups);

  function MentorGroups(props) {
    var _this;

    _classCallCheck(this, MentorGroups);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.setPageTitle(_this.props.translate('mentor-header-overview'));

      if (_this.props.mentorGroups == null || _this.props.mentorGroups.length == 0) {
        _this.setState({
          isLoadingSections: true
        });

        _this.props.getMentorGroups().then(function () {
          if (_this.props.mentorGroups != null && _this.props.mentorGroups.length > 0) {
            _this.props.mentorGroups.forEach(function (group) {
              if (group.absences == null && group.currentUserRole == 'OWNER') {
                _this.props.getGroupAbsenceForToday(group.id, encodeURIComponent(moment().format()), encodeURIComponent(moment().add(1, 'd').format()));
              }
            });
          }
        });
      }

      if (_this.props.mentorArchivedGroups == null || _this.props.mentorArchivedGroups.length == 0) {
        _this.props.getArchievedMentorGroups().then(function () {
          _this.setState({
            isLoadingSections: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      return _this.setState({
        expand: !_this.state.expand
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFoldButton", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        end: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "all-fold-button color--meta ".concat(_this.state.expand ? 'open' : 'closed'),
        onClick: _this.toggleExpand
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), _this.state.expand ? _this.props.translate('Hide description') : _this.props.translate('Show description')));
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
        var filter;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(values.query == null || values.query == '')) {
                  _context.next = 3;
                  break;
                }

                _this.props.clearSearch();

                return _context.abrupt("return", true);

              case 3:
                if (!(values.query.length < 3)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:
                _this.setState({
                  loading: true
                });

                filter = 'LINKED;MENTOR_GROUP';
                _context.next = 9;
                return _this.props.searchGroups({
                  query: values.query,
                  filter: filter
                });

              case 9:
                _this.setState({
                  loading: false
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderGroup", function (group, index) {
      var foundInvalid = [];
      var foundValid = [];

      if (group.absences != null && group.absences.length > 0) {
        group.absences.forEach(function (absence) {
          var inInvalid = foundInvalid.find(function (student) {
            return student.userId == absence.user.userId;
          });

          if (absence.type == 'INVALID_ABSENCE') {
            if (inInvalid == null) {
              foundInvalid.push(absence.user);
            }
          }
        });
        group.absences.forEach(function (absence) {
          var inInvalid = foundInvalid.find(function (student) {
            return student.userId == absence.user.userId;
          });
          var inValid = foundValid.find(function (student) {
            return student.userId == absence.user.userId;
          });

          if (absence.type == 'VALID_ABSENCE') {
            if (inInvalid == null && inValid == null) {
              foundValid.push(absence.user);
            }
          }
        });
      }

      var cardTitle = /*#__PURE__*/React.createElement("div", {
        className: "group-header"
      }, /*#__PURE__*/React.createElement("span", {
        className: "header-title"
      }, group.title), foundInvalid.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#f25252'
        }
      }, foundInvalid.length + ' ' + _this.props.translate('absent').toLowerCase()) : null, foundValid.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#ff883e'
        }
      }, foundValid.length + ' ' + _this.props.translate('valid-absent').toLowerCase()) : null);
      return /*#__PURE__*/React.createElement(Card, {
        element: Link,
        to: "/groups/".concat(group.id),
        style: {
          marginBottom: '0.75rem'
        },
        key: 'group-' + group.id + '-' + index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: cardTitle,
        open: _this.state.expand
      }, /*#__PURE__*/React.createElement(Flex, {
        top: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "description size-14"
      }, _this.cutDescription(group.description)), /*#__PURE__*/React.createElement("div", {
        className: "size-14"
      }, group.events != null ? group.events.map(function (event, index) {
        return /*#__PURE__*/React.createElement(Flex, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "event-date"
        }, new DateTime(event.created).getDateStamp()), /*#__PURE__*/React.createElement("div", {
          className: "event-text"
        }, event.createdBy.firstName + ' ' + event.createdBy.lastName + ' ' + _this.props.translate(event.event)));
      }) : null))), /*#__PURE__*/React.createElement("div", {
        className: "meta-container",
        style: {
          marginTop: '.5rem'
        }
      }, group.archived ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Archived')) : null, group.currentUserRole == 'OWNER' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Owner')) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Member')))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilters", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: _this.props.translate('Search group'),
        onSubmit: _this.onSearch,
        allowEmpty: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "GroupList", function () {
      if (_this.props.searchResults != null && _this.props.searchResults.length > 0) {
        return /*#__PURE__*/React.createElement("div", null, _this.props.searchResults.map(_this.renderGroup));
      }

      var groups = JSON.parse(JSON.stringify(_this.props.mentorGroups));

      if (groups != null) {
        groups = groups.filter(function (group) {
          return group.currentUserRole == 'OWNER';
        });
        return /*#__PURE__*/React.createElement("div", null, groups.map(_this.renderGroup));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ArchivedGroupList", function () {
      var groups = JSON.parse(JSON.stringify(_this.props.mentorArchivedGroups));

      if (groups != null) {
        groups = groups.filter(function (group) {
          return group.currentUserRole == 'OWNER';
        });
        return /*#__PURE__*/React.createElement("div", null, groups.map(_this.renderGroup));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "noGroupsFound", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-sections-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "cutDescription", function (description) {
      if (description == null) {
        return '';
      }

      var strippedDescription = getDescription(description).replace(/(<([^>]+)>)/ig, '');

      if (strippedDescription.length > 99) {
        return strippedDescription.slice(0, 100) + '…';
      }

      return strippedDescription;
    });

    _this.state = {
      expand: false,
      isLoadingSections: false
    };
    return _this;
  }

  _createClass(MentorGroups, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "page groups"
      }, this.renderFilters(), this.renderFoldButton(), this.GroupList(), this.props.mentorArchivedGroups.length > 0 ? this.ArchivedGroupList() : null, this.state.isLoadingSections ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : null, !this.state.isLoadingSections && this.props.mentorGroups != null && this.props.mentorGroups.length == 0 ? this.noGroupsFound() : null);
    }
  }]);

  return MentorGroups;
}(Component);

function mapStateToProps(state) {
  return {
    mentorGroups: state.sections.mentorGroups,
    mentorArchivedGroups: state.sections.mentorArchievedGroups,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    searchResults: state.Search.groups
  };
}

export default connect(mapStateToProps, {
  getMentorGroups: getMentorGroups,
  getArchievedMentorGroups: getArchievedMentorGroups,
  getGroupAbsenceForToday: getGroupAbsenceForToday,
  setPageTitle: setPageTitle,
  searchGroups: searchGroups,
  clearSearch: clearSearch
})(MentorGroups);